import { useEffect } from "react";

const IframeScrollHandler = () => {
  useEffect(() => {
    if (window.self === window.top) return;
    
    const params = new URLSearchParams(window.location.search);
    const scrollTarget = params.get('iframeScroll');
    if (scrollTarget) {
      const tryScroll = () => {
        const el = document.getElementById(scrollTarget);
        if (el) {
          window.scrollTo(0, el.offsetTop);
        } else {
          setTimeout(tryScroll, 200);
        }
      };
      setTimeout(tryScroll, 500);
    }
  }, []);
  return null;
};

export default IframeScrollHandler;
